<template>
		<v-menu
			ref="projectTypeSelectMenu"
			offset-y
			offset-x
			left
			:close-on-content-click="false"
			max-width="500"
			min-width="500"
			content-class="menu-bg-white"
			style="z-index: 9999; background-color: white;">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					icon
					color="warning"
					x-small
					:disabled="isDisabled"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
				</v-btn>
			</template>
			<v-list dense class="py-0" max-height="400" style="z-index: 9999;background-color: white;">
				<v-list-item dense style="min-height: 25px; background: #524D4D">
					<div class="d-flex align-center justify-space-between my-1" style="width: 100%">
						<p class="caption mb-0 font-weight-bold white--text">Cambiar Destino</p>
						<div>
							<v-text-field
								v-model="searchProjectTypeInput"
								outlined
								dense
								hide-details
								label="Búsqueda"
								class="custom-height-search custom-height-calendar"
								dark
								color="white"
							></v-text-field>
						</div>
					</div>
				</v-list-item>
				<v-list-item-group color="#524D4D">
					<v-list-item
						v-for="(destiny, index) in companyProjectDestinies"
						:key="index"
						dense
						@click.stop="projectDestinyChange(destiny)"
					>
						<v-list-item-content>
							<v-list-item-title dense>
								<div class="d-flex align-center justify-space-between">
									{{ destiny.name }}
								</div>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-menu>
</template>

<script>
export default {
	name: "ProjectDestinySelectorMenu",
	props: {
		onClick: {
			type: Function,
			required: true
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			searchProjectTypeInput: null,
			hideSubTypes: []
		}
	},
	computed: {
		companyProjectDestinies() {
			return this.$store.state.companies.companyProjectDestinies
		},
	},
	mounted(){
		this.reloadInfo()
	},
	methods: {
		reloadInfo(){
			let data = {
				start: 0,
				limit: 1000
			}
			this.$store.dispatch('companies/getCompanyProjectDestinies', data)
		},
		projectDestinyChange(destiny) {
			this.$refs.projectTypeSelectMenu.isActive = false
			this.onClick(destiny)
		}
	}
}
</script>